"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonPageGrid = exports.OktonEmptyState = exports.OktonField = exports.OktonToolbar = exports.OktonButton = exports.OktonStatCard = exports.OktonPanel = exports.OktonPageHeader = exports.OktonPage = void 0;
const react_1 = __importDefault(require("react"));
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
function usePagePalette() {
    const { theme } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const dark = theme === "dark";
    return {
        page: dark ? "#111827" : "#F7FAFC",
        panel: dark ? "#1F2937" : "#FFFFFF",
        panelAlt: dark ? "#273142" : "#F7FAFC",
        border: dark ? "#374151" : "#E2E8F0",
        text: dark ? "#F7FAFC" : "#2D3748",
        muted: dark ? "#A0AEC0" : "#718096",
        primary: dark ? "#4299E1" : "#3182CE",
    };
}
const OktonPage = ({ children, style }) => {
    const palette = usePagePalette();
    return (react_1.default.createElement("div", { className: "okton-integra-page", style: Object.assign({ minHeight: "100%", padding: "32px 24px", background: palette.page, color: palette.text, ["--okton-page-panel"]: palette.panel, ["--okton-page-panel-alt"]: palette.panelAlt, ["--okton-page-border"]: palette.border, ["--okton-page-text"]: palette.text, ["--okton-page-muted"]: palette.muted, ["--okton-page-primary"]: palette.primary }, style) },
        react_1.default.createElement("style", null, `
        .okton-integra-page .bg-card {
          background: var(--okton-page-panel) !important;
        }
        .okton-integra-page .text-card-foreground,
        .okton-integra-page .text-foreground {
          color: var(--okton-page-text) !important;
        }
        .okton-integra-page .text-muted-foreground {
          color: var(--okton-page-muted) !important;
        }
        .okton-integra-page .border,
        .okton-integra-page .border-border,
        .okton-integra-page .border-input {
          border-color: var(--okton-page-border) !important;
        }
        .okton-integra-page .rounded-xl.border.bg-card {
          border-radius: 16px !important;
          box-shadow: 0 1px 4px rgba(15, 23, 42, .08) !important;
        }
        .okton-integra-page input,
        .okton-integra-page textarea,
        .okton-integra-page select {
          border-color: var(--okton-page-border) !important;
          border-radius: 8px !important;
          background: var(--okton-page-panel) !important;
          color: var(--okton-page-text) !important;
        }
        .okton-integra-page input:not([type="checkbox"]):not([type="radio"]) {
          min-height: 40px;
        }
        .okton-integra-page button {
          border-radius: 8px;
        }
        @media (max-width: 720px) {
          .okton-integra-page { padding: 24px 16px !important; }
          .okton-page-grid { grid-template-columns: 1fr !important; }
        }
      `),
        children));
};
exports.OktonPage = OktonPage;
const OktonPageHeader = ({ title, subtitle, actions, eyebrow, onBack, backLabel = "Voltar" }) => {
    const palette = usePagePalette();
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 20,
            marginBottom: 24,
            flexWrap: "wrap",
        } },
        react_1.default.createElement("div", { style: { display: "flex", alignItems: "flex-start", gap: 10, minWidth: 0 } },
            onBack ? (react_1.default.createElement("button", { type: "button", "aria-label": backLabel, title: backLabel, onClick: onBack, style: {
                    width: 36,
                    height: 36,
                    border: 0,
                    borderRadius: 8,
                    background: "transparent",
                    color: palette.text,
                    cursor: "pointer",
                    fontSize: 24,
                    lineHeight: 1,
                    flexShrink: 0,
                } }, "\u2190")) : null,
            react_1.default.createElement("div", { style: { minWidth: 0 } },
                eyebrow ? (react_1.default.createElement("div", { style: {
                        marginBottom: 3,
                        fontSize: 11,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        color: palette.muted,
                    } }, eyebrow)) : null,
                react_1.default.createElement("h1", { style: {
                        margin: 0,
                        fontSize: 25,
                        lineHeight: 1.25,
                        fontWeight: 700,
                        color: palette.text,
                    } }, title),
                subtitle ? (react_1.default.createElement("div", { style: {
                        marginTop: 6,
                        maxWidth: 760,
                        fontSize: 14,
                        lineHeight: 1.55,
                        color: palette.muted,
                    } }, subtitle)) : null)),
        actions ? (react_1.default.createElement("div", { style: { display: "flex", gap: 10, flexWrap: "wrap" } }, actions)) : null));
};
exports.OktonPageHeader = OktonPageHeader;
const OktonPanel = ({ title, subtitle, headerActions, children, style, bodyStyle }) => {
    const palette = usePagePalette();
    const hasHeader = Boolean(title || subtitle || headerActions);
    return (react_1.default.createElement("section", { style: Object.assign({ width: "100%", overflow: "hidden", border: `1px solid ${palette.border}`, borderRadius: 16, background: palette.panel, boxShadow: "0 1px 4px rgba(15, 23, 42, 0.08)" }, style) },
        hasHeader ? (react_1.default.createElement("div", { style: {
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 16,
                padding: "18px 20px",
                borderBottom: `1px solid ${palette.border}`,
            } },
            react_1.default.createElement("div", null,
                title ? (react_1.default.createElement("div", { style: { fontSize: 18, fontWeight: 700, color: palette.text } }, title)) : null,
                subtitle ? (react_1.default.createElement("div", { style: { marginTop: 4, fontSize: 13, color: palette.muted } }, subtitle)) : null),
            headerActions)) : null,
        react_1.default.createElement("div", { style: Object.assign({ padding: 20 }, bodyStyle) }, children)));
};
exports.OktonPanel = OktonPanel;
const OktonStatCard = ({ label, value, icon, accent = "#3182CE", detail, onClick }) => {
    const palette = usePagePalette();
    return (react_1.default.createElement("button", { type: "button", onClick: onClick, disabled: !onClick, style: {
            width: "100%",
            minHeight: 150,
            padding: 20,
            border: `1px solid ${palette.border}`,
            borderRadius: 12,
            background: palette.panel,
            color: palette.text,
            boxShadow: "0 1px 4px rgba(15, 23, 42, 0.08)",
            textAlign: "left",
            cursor: onClick ? "pointer" : "default",
        } },
        react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: 16 } },
            icon ? (react_1.default.createElement("span", { style: {
                    width: 42,
                    height: 42,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: `2px solid ${accent}`,
                    borderRadius: 8,
                    color: accent,
                } }, react_1.default.createElement(icon, { size: 20 }))) : (react_1.default.createElement("span", null)),
            detail ? (react_1.default.createElement("span", { style: { fontSize: 12, color: palette.muted } }, detail)) : null),
        react_1.default.createElement("div", { style: { marginTop: 22, fontSize: 13, color: palette.muted } }, label),
        react_1.default.createElement("div", { style: { marginTop: 5, fontSize: 28, fontWeight: 700 } }, value)));
};
exports.OktonStatCard = OktonStatCard;
const OktonButton = (_a) => {
    var _b;
    var { variant = "primary", icon, children, style } = _a, props = __rest(_a, ["variant", "icon", "children", "style"]);
    const palette = usePagePalette();
    const variants = {
        primary: {
            background: "#3182CE",
            color: "#FFFFFF",
            border: "1px solid #3182CE",
        },
        secondary: {
            background: "transparent",
            color: palette.text,
            border: `1px solid ${palette.border}`,
        },
        danger: {
            background: "#E53E3E",
            color: "#FFFFFF",
            border: "1px solid #E53E3E",
        },
        ghost: {
            background: "transparent",
            color: palette.text,
            border: "1px solid transparent",
        },
    };
    return (react_1.default.createElement("button", Object.assign({}, props, { type: (_b = props.type) !== null && _b !== void 0 ? _b : "button", style: Object.assign(Object.assign({ minHeight: 40, padding: "0 16px", borderRadius: 8, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, fontSize: 14, fontWeight: 600, cursor: props.disabled ? "not-allowed" : "pointer", opacity: props.disabled ? 0.6 : 1 }, variants[variant]), style) }),
        icon ? react_1.default.createElement(icon, { size: 16 }) : null,
        children));
};
exports.OktonButton = OktonButton;
const OktonToolbar = ({ children, }) => {
    const palette = usePagePalette();
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
            padding: 16,
            border: `1px solid ${palette.border}`,
            borderRadius: 12,
            background: palette.panel,
        } }, children));
};
exports.OktonToolbar = OktonToolbar;
const OktonField = ({ label, hint, children }) => {
    const palette = usePagePalette();
    return (react_1.default.createElement("label", { style: { display: "grid", gap: 7, minWidth: 0 } },
        react_1.default.createElement("span", { style: { fontSize: 13, fontWeight: 600, color: palette.text } }, label),
        children,
        hint ? (react_1.default.createElement("span", { style: { fontSize: 11, lineHeight: 1.45, color: palette.muted } }, hint)) : null));
};
exports.OktonField = OktonField;
const OktonEmptyState = ({ icon, title, description, action }) => {
    const palette = usePagePalette();
    return (react_1.default.createElement("div", { style: {
            minHeight: 240,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            padding: 28,
            textAlign: "center",
            color: palette.text,
        } },
        icon
            ? react_1.default.createElement(icon, { size: 40, color: palette.muted })
            : null,
        react_1.default.createElement("div", { style: { fontSize: 16, fontWeight: 600 } }, title),
        description ? (react_1.default.createElement("div", { style: { maxWidth: 520, fontSize: 13, color: palette.muted } }, description)) : null,
        action ? react_1.default.createElement("div", { style: { marginTop: 6 } }, action) : null));
};
exports.OktonEmptyState = OktonEmptyState;
const OktonPageGrid = ({ children, columns = 2, gap = 16 }) => (react_1.default.createElement("div", { style: {
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        gap,
    }, className: "okton-page-grid" }, children));
exports.OktonPageGrid = OktonPageGrid;
//# sourceMappingURL=index.js.map